import ExportButtonWithLoader from '@creditflowresearch/uilib/ExportButtonWithLoader';
import { ISelectOption } from '@creditflowresearch/uilib/Select';
import Flex from '@creditflowresearch/uilib/Flex';
import { useRouter } from 'next/router';
import { useTopCompaniesAccess } from '@/creditflowresearch/ui/components/TopCompanies/common/useTopCompaniesAccess';
import { useIsGuest } from '@/creditflowresearch/application/User/access';
import { useAccessGrant } from '@/creditflowresearch/application/User/access/grants/useAccessGrant';
import { PATH_ONLY_GRANT_CONTEXT } from '@/creditflowresearch/application/User/access/grants/pagePatterns';
import TTMSelect from '@/creditflowresearch/ui/common/components/atoms/TTMSelect';

import styles from './topCompaniesActions.module.scss';

const TopCompaniesActions = ({ commonData }) => {
  const { query: { companyViewId } } = useRouter();
  const isAccessible = useTopCompaniesAccess();
  const isGuest = useIsGuest();
  // TODO: remove when the European market opening period ends
  const isOpenAccessPage = useAccessGrant(PATH_ONLY_GRANT_CONTEXT);
  // TODO: remove when the European market opening period ends (US-5745)
  const isOpenAccessRequest = useAccessGrant();
  // TODO: remove when the European market opening period ends
  const isPeriodSelectDisabled = isGuest
    ? !isOpenAccessRequest
    : !(isOpenAccessPage || isAccessible);
  const {
    isExportAvailable,
    isExportFetching,
    exportToExcel,
    selectedPeriod,
    setSelectedPeriod,
    periodsCollection,
  } = commonData;

  const dataTest = companyViewId ? 'exportTopCompaniesParent' : 'exportTopCompaniesProfile';

  const onChange = (option: ISelectOption): void => {
    if (option) {
      setSelectedPeriod(option);
    }
  };

  return (
    <Flex gap={ 10 } align="center">
      <TTMSelect
        value={ selectedPeriod }
        options={ periodsCollection }
        onChange={ onChange }
        isOptionDisabled={ (option) => option.disabled }
        dataTest={ companyViewId ? 'topCompaniesTTMFilterSelectParent' : 'topCompaniesTTMFilterSelectProfile' }
        isDisabled={ isPeriodSelectDisabled }
        formFieldClassName={ styles.periodSelect }
      />
      <ExportButtonWithLoader
        onClick={ exportToExcel }
        isFetching={ isExportFetching }
        isDisabled={ !isAccessible || !isExportAvailable }
        tooltipContent="Export to Excel"
        disabledTooltipContent="Export to Excel not available"
        buttonSize="S"
        dataTest={ dataTest }
        ariaLabel="Export to Excel"
      />
    </Flex>
  );
};

export default TopCompaniesActions;
